import { render, staticRenderFns } from "./SiteAppChiseCms.vue?vue&type=template&id=28021c7d&scoped=true&"
import script from "./SiteAppChiseCms.vue?vue&type=script&lang=js&"
export * from "./SiteAppChiseCms.vue?vue&type=script&lang=js&"
import style0 from "./SiteAppChiseCms.vue?vue&type=style&index=0&id=28021c7d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28021c7d",
  null
  
)

export default component.exports